module.exports = __webpack_public_path__ + "img/logo.7b7e0850.jpg";